import { render, staticRenderFns } from "./OrgSwitchPromptDialog.vue?vue&type=template&id=17a919cf"
import script from "./OrgSwitchPromptDialog.vue?vue&type=script&lang=js"
export * from "./OrgSwitchPromptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports